/**
 * Match cart variant to one line in product expairy_date metafield.
 * Format: "Flavor · Mar 2027" per line.
 */
(function () {
  'use strict';

  var expiryCache = {};
  var productCache = {};

  var MONTHS = {
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11,
  };

  function isArabic() {
    var lang = String(document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('ar') === 0) return true;
    if (document.documentElement.getAttribute('dir') === 'rtl') return true;
    if (window.Shopify && window.Shopify.locale && String(window.Shopify.locale).toLowerCase().indexOf('ar') === 0) {
      return true;
    }
    return false;
  }

  function getLabel() {
    return isArabic() ? 'ينتهي:' : 'Exp:';
  }

  /** Primary-language storefront routes (English), not /ar/ localized paths. */
  function defaultApiRoot() {
    return '/';
  }

  function decodeHtml(str) {
    var t = document.createElement('textarea');
    t.innerHTML = String(str || '');
    return t.value;
  }

  function normalizeDots(str) {
    return String(str || '').replace(/\u00b7|\u2022|\u2027|&#183;|&middot;/gi, '·');
  }

  function htmlToPlainLines(raw) {
    var html = normalizeDots(decodeHtml(raw));
    html = html
      .replace(/<\/li>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]+>/g, ' ');
    return html
      .split(/\n+|\|+/)
      .map(function (s) {
        return s.replace(/\s+/g, ' ').trim();
      })
      .filter(Boolean);
  }

  function parseExpiryLines(raw) {
    return htmlToPlainLines(raw);
  }

  function extractFlavorDatePairs(raw) {
    var pairs = [];
    var seen = {};
    var plain = normalizeDots(decodeHtml(raw)).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ');
    var re = /([A-Za-z][A-Za-z0-9][A-Za-z0-9 \-\/]*?)\s*·\s*([A-Za-z]{3,9}\s+\d{4})/g;
    var match;
    while ((match = re.exec(plain))) {
      var flavor = match[1].trim();
      var date = match[2].trim();
      var key = normalizeFlavor(flavor) + '|' + date;
      if (!seen[key]) {
        seen[key] = true;
        pairs.push({ flavor: flavor, date: date });
      }
    }
    return pairs;
  }

  function normalizeFlavor(s) {
    return String(s || '')
      .toLowerCase()
      .trim()
      .split('/')[0]
      .split('|')[0]
      .split(' - ')[0]
      .replace(/\s+/g, ' ')
      .trim();
  }

  function splitFlavorDate(line) {
    var normalized = line.replace(/\u00b7|\u2022|\u2027/g, '·');
    var idx = normalized.indexOf('·');
    if (idx > 0) {
      return {
        flavor: normalized.slice(0, idx).trim(),
        date: normalized.slice(idx + 1).trim(),
      };
    }

    var dash = normalized.match(/^(.+?)\s+[-–—]\s+(.+)$/);
    if (dash) {
      return { flavor: dash[1].trim(), date: dash[2].trim() };
    }
    return null;
  }

  function scoreFlavorMatch(flavor, vt) {
    if (!flavor || !vt) return 0;
    if (flavor === vt) return 10000;
    if (vt.indexOf(flavor) !== -1) return flavor.length;
    if (flavor.indexOf(vt) !== -1) return vt.length;
    return 0;
  }

  function matchVariantExpiry(raw, variantTitle) {
    var vt = normalizeFlavor(variantTitle);
    if (!vt || !raw) return null;

    var pairs = [];
    var lines = parseExpiryLines(raw);

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (!line || line.length < 3) continue;

      var pair = splitFlavorDate(line);
      if (pair && pair.date) {
        pairs.push(pair);
      }
    }

    if (!pairs.length) {
      pairs = extractFlavorDatePairs(raw);
    }

    var bestDate = null;
    var bestScore = 0;

    for (var j = 0; j < pairs.length; j++) {
      var flavor = normalizeFlavor(pairs[j].flavor);
      if (!flavor) continue;

      var score = scoreFlavorMatch(flavor, vt);
      if (score > bestScore) {
        bestScore = score;
        bestDate = pairs[j].date;
      }
    }

    return bestDate;
  }

  function parseExpiryEndDate(dateStr) {
    var text = String(dateStr || '').trim();
    var monthYear = text.match(/^([A-Za-z]{3,9})\s+(\d{4})$/);
    if (monthYear) {
      var mon = MONTHS[monthYear[1].toLowerCase().slice(0, 3)];
      var year = parseInt(monthYear[2], 10);
      if (!isNaN(mon) && !isNaN(year)) {
        return new Date(year, mon + 1, 0);
      }
    }
    var parsed = new Date(text);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  function daysUntilExpiry(dateStr) {
    var end = parseExpiryEndDate(dateStr);
    if (!end) return null;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return Math.ceil((end.getTime() - today.getTime()) / 86400000);
  }

  function urgencyClass(dateStr) {
    var days = daysUntilExpiry(dateStr);
    if (days === null) return 'mm-variant-expiry__pill--ok';
    if (days < 30) return 'mm-variant-expiry__pill--critical';
    if (days <= 90) return 'mm-variant-expiry__pill--warning';
    return 'mm-variant-expiry__pill--ok';
  }

  function readRawFromEl(el) {
    var script = el.querySelector('script.mm-expiry-payload');
    if (script && script.textContent) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (typeof parsed === 'string' && parsed) return parsed;
      } catch (e) {
        var plain = script.textContent.trim();
        if (plain) return plain;
      }
    }
    return el.getAttribute('data-expiry-raw') || '';
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    var url = defaultApiRoot() + 'products/' + encodeURIComponent(handle) + '.js';
    productCache[handle] = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('product');
        return r.json();
      })
      .catch(function () {
        return null;
      });

    return productCache[handle];
  }

  function variantEnglishTitles(product, variantId) {
    if (!product || !variantId) return [];

    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (String(v.id) !== String(variantId)) continue;

      var titles = [];
      if (v.option1) titles.push(v.option1);
      if (v.title && v.title !== 'Default Title' && titles.indexOf(v.title) === -1) {
        titles.push(v.title);
      }
      if (v.option2 && titles.indexOf(v.option2) === -1) titles.push(v.option2);
      if (v.option3 && titles.indexOf(v.option3) === -1) titles.push(v.option3);
      return titles;
    }

    return [];
  }

  function variantMatchTitles(product, variantId, variantTitle) {
    if (isArabic()) {
      return variantEnglishTitles(product, variantId);
    }

    var titles = variantEnglishTitles(product, variantId);
    if (variantTitle && titles.indexOf(variantTitle) === -1) titles.push(variantTitle);
    return titles;
  }

  function resolveExpiryDate(rawText, variantTitle, handle, variantId) {
    if (!handle || !variantId) {
      if (isArabic()) return Promise.resolve(null);
      return Promise.resolve(matchVariantExpiry(rawText, variantTitle));
    }

    return fetchProduct(handle).then(function (product) {
      var titles = variantMatchTitles(product, variantId, variantTitle);
      for (var i = 0; i < titles.length; i++) {
        var date = matchVariantExpiry(rawText, titles[i]);
        if (date) return date;
      }
      return null;
    });
  }

  function renderExpiry(el, date) {
    if (!el || !date) {
      if (el) el.innerHTML = '';
      el && el.classList.remove('mm-variant-expiry--visible');
      return;
    }

    var pillClass = urgencyClass(date);
    el.classList.add('mm-variant-expiry--visible');
    el.innerHTML =
      '<span class="mm-variant-expiry__pill ' +
      pillClass +
      '" role="text">' +
      '<span class="mm-variant-expiry__icon" aria-hidden="true">📅</span>' +
      '<span class="mm-variant-expiry__label">' +
      getLabel() +
      '</span>' +
      '<span class="mm-variant-expiry__date" dir="ltr">' +
      date +
      '</span>' +
      '</span>';
  }

  function fetchProductExpiry(handle) {
    if (!handle) return Promise.resolve(null);
    if (expiryCache[handle]) return expiryCache[handle];

    var url = defaultApiRoot() + 'products/' + encodeURIComponent(handle) + '?view=mm-cart-meta';
    expiryCache[handle] = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('meta');
        return r.text();
      })
      .then(function (text) {
        var data = null;
        try {
          data = JSON.parse(text.trim());
        } catch (e) {
          return null;
        }
        return (data && data.expairy_date) || null;
      })
      .catch(function () {
        return null;
      });

    return expiryCache[handle];
  }

  function hydrateOne(el) {
    if (!el) return Promise.resolve();

    var variantTitle = el.getAttribute('data-variant-title') || '';
    var handle = el.getAttribute('data-product-handle') || '';
    var variantId = el.getAttribute('data-variant-id') || '';
    var raw = readRawFromEl(el);

    function finish(date) {
      if (!date) {
        el.innerHTML = '';
        el.classList.remove('mm-variant-expiry--visible');
        el.setAttribute('data-mm-expiry-empty', '1');
        return;
      }
      el.removeAttribute('data-mm-expiry-empty');
      renderExpiry(el, date);
    }

    function apply(rawText) {
      return resolveExpiryDate(rawText, variantTitle, handle, variantId).then(finish);
    }

    if (raw) {
      return apply(raw);
    }

    if (!handle) {
      el.innerHTML = '';
      return Promise.resolve();
    }

    return fetchProductExpiry(handle).then(function (fetched) {
      return apply(fetched || '');
    });
  }

  function hydrate(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('[data-mm-variant-expiry]');
    if (!nodes.length) return Promise.resolve();
    return Promise.all(
      Array.prototype.map.call(nodes, function (el) {
        return hydrateOne(el);
      })
    );
  }

  function resetAndHydrate(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-mm-variant-expiry]').forEach(function (el) {
      el.removeAttribute('data-mm-expiry-empty');
      var keepPayload = el.querySelector('script.mm-expiry-payload');
      if (!keepPayload) {
        el.innerHTML = '';
      } else {
        var payload = keepPayload.outerHTML;
        el.innerHTML = payload;
      }
    });
    return hydrate(root);
  }

  window.MMVariantExpiry = {
    hydrate: hydrate,
    resetAndHydrate: resetAndHydrate,
    matchVariantExpiry: matchVariantExpiry,
    clearCache: function () {
      expiryCache = {};
      productCache = {};
    },
  };

  function boot(scope) {
    resetAndHydrate(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('cart:updated', function () {
    window.MMVariantExpiry.clearCache();
    boot(document);
  });
})();
